import React, { Component } from 'react';
import { Modal, ModalBodyCopy, ModalHeader, ModalButtonContainer } from '@zocdoc/components/src/modal';
import { Button, ButtonGroup } from '@zocdoc/components/src/button';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';

const StyledButtonGroup = styled(ButtonGroup)`
    ${breakpoint.small} {
        display: flex;
    }
`;

export default class ModalView extends Component {
    render() {
        return (
            <Modal onClickCancel={this.props.onClickCancel}>
                <div>
                    <ModalHeader>{this.props.header}</ModalHeader>
                    <ModalBodyCopy>{this.props.message}</ModalBodyCopy>

                    {this.props.additionalMessage ?
                        <ModalBodyCopy>{this.props.additionalMessage}</ModalBodyCopy> : undefined}

                    <ModalButtonContainer>
                        <StyledButtonGroup>
                            <Button
                                data-prod-guids="modal-primary-button:[4c2b7f86]"
                                fluid
                                href={this.props.primaryActionHref}
                                onClick={this.props.onClickPrimaryAction}
                            >
                                {this.props.primaryActionText}
                            </Button>
                            <Button
                                data-prod-guids="modal-secondary-button:[4c2b7f86]"
                                fluid
                                onClick={this.props.onClickSecondaryAction}
                                style={Button.STYLE.TRANSPARENT}
                            >
                                {this.props.secondaryActionText}
                            </Button>
                        </StyledButtonGroup>
                    </ModalButtonContainer>
                </div>
            </Modal>
        );
    }
}
